export var TypeStoreOrderStatusKeyEnum;
(function (TypeStoreOrderStatusKeyEnum) {
    TypeStoreOrderStatusKeyEnum["NEW"] = "new";
    TypeStoreOrderStatusKeyEnum["DELAYED"] = "delayed";
    TypeStoreOrderStatusKeyEnum["RECEIVED"] = "received";
    TypeStoreOrderStatusKeyEnum["READY"] = "ready";
    TypeStoreOrderStatusKeyEnum["COMPLETE"] = "complete";
    TypeStoreOrderStatusKeyEnum["CANCELED"] = "canceled";
    TypeStoreOrderStatusKeyEnum["CLEARED"] = "cleared";
    TypeStoreOrderStatusKeyEnum["TEST"] = "test";
    TypeStoreOrderStatusKeyEnum["REFUNDED"] = "refunded";
})(TypeStoreOrderStatusKeyEnum || (TypeStoreOrderStatusKeyEnum = {}));
export var StoreOrderStatusEnum;
(function (StoreOrderStatusEnum) {
    StoreOrderStatusEnum["DELAYED"] = "delayed";
    StoreOrderStatusEnum["DELAYED_PAY"] = "delayed_pay";
    StoreOrderStatusEnum["NEW"] = "new";
    StoreOrderStatusEnum["RECEIVED"] = "received";
    StoreOrderStatusEnum["READY"] = "ready";
    StoreOrderStatusEnum["COMPLETE"] = "complete";
    StoreOrderStatusEnum["CANCELED"] = "canceled";
    StoreOrderStatusEnum["CLEARED"] = "cleared";
    StoreOrderStatusEnum["REFUNDED"] = "refunded";
    StoreOrderStatusEnum["TEST"] = "test";
})(StoreOrderStatusEnum || (StoreOrderStatusEnum = {}));
export var TypeStoreOrderStatusValueEnum;
(function (TypeStoreOrderStatusValueEnum) {
    TypeStoreOrderStatusValueEnum["NEW"] = "New";
    TypeStoreOrderStatusValueEnum["DELAYED"] = "Delayed";
    TypeStoreOrderStatusValueEnum["ORDER_AHEAD"] = "Order Ahead";
    TypeStoreOrderStatusValueEnum["RECEIVED"] = "Received";
    TypeStoreOrderStatusValueEnum["READY"] = "Ready";
    TypeStoreOrderStatusValueEnum["COMPLETE"] = "Complete";
    TypeStoreOrderStatusValueEnum["CANCELED"] = "Canceled";
    TypeStoreOrderStatusValueEnum["CLEARED"] = "Cleared";
    TypeStoreOrderStatusValueEnum["TEST"] = "Test Order";
    TypeStoreOrderStatusValueEnum["REFUNDED"] = "Refund";
    TypeStoreOrderStatusValueEnum["IN_PROGRESS"] = "In progress";
})(TypeStoreOrderStatusValueEnum || (TypeStoreOrderStatusValueEnum = {}));
export var TypeStoreOrderStatusColorEnum;
(function (TypeStoreOrderStatusColorEnum) {
    TypeStoreOrderStatusColorEnum["RED"] = "red";
    TypeStoreOrderStatusColorEnum["YELLOW"] = "yellow";
    TypeStoreOrderStatusColorEnum["GREEN"] = "green";
    TypeStoreOrderStatusColorEnum["GREY"] = "grey";
})(TypeStoreOrderStatusColorEnum || (TypeStoreOrderStatusColorEnum = {}));
export var TypeStoreOrderStatusGroupEnum;
(function (TypeStoreOrderStatusGroupEnum) {
    TypeStoreOrderStatusGroupEnum["IN_PROGRESS"] = "in progress";
    TypeStoreOrderStatusGroupEnum["COMPLETE"] = "complete";
    TypeStoreOrderStatusGroupEnum["DELAYED"] = "delayed";
    TypeStoreOrderStatusGroupEnum["VOID"] = "void";
})(TypeStoreOrderStatusGroupEnum || (TypeStoreOrderStatusGroupEnum = {}));
export var TypeStoreOrderStatusNotifyUserWorkflowEnum;
(function (TypeStoreOrderStatusNotifyUserWorkflowEnum) {
    TypeStoreOrderStatusNotifyUserWorkflowEnum["COMPLETE_ORDER_STATUS_CHANGE_NEW"] = "COMPLETE_ORDER_STATUS_CHANGE_NEW";
    TypeStoreOrderStatusNotifyUserWorkflowEnum["COMPLETE_ORDER_STATUS_CHANGE_RECEIVED"] = "COMPLETE_ORDER_STATUS_CHANGE_RECEIVED";
    TypeStoreOrderStatusNotifyUserWorkflowEnum["COMPLETE_ORDER_STATUS_CHANGE_READY"] = "COMPLETE_ORDER_STATUS_CHANGE_READY";
    TypeStoreOrderStatusNotifyUserWorkflowEnum["COMPLETE_ORDER_STATUS_CHANGE_COMPLETE"] = "COMPLETE_ORDER_STATUS_CHANGE_COMPLETE";
})(TypeStoreOrderStatusNotifyUserWorkflowEnum || (TypeStoreOrderStatusNotifyUserWorkflowEnum = {}));
//# sourceMappingURL=store-order-status.enum.js.map